<script setup lang="ts">
  const app = useAppConfig()
  import { useLocalStorageRouteCheck } from '~/composables/useLocalStorageRouteCheck';

  const localStorageKey = 'products'; // Replace with your key
  const allowedRouteNames = ['/surveys/create', '/products/create'];

  // global meta information can be added to the head
  useHead({
    titleTemplate: (titleChunk) => {
      return titleChunk
        ? `${titleChunk} - ${app.tairo?.title}`
        : `${app.tairo?.title}`
    },
    htmlAttrs: {
      lang: 'en',
      dir: 'ltr',
    },
    link: [      
      /* {
        rel: 'preload',
        as: 'image',
        href: '/img/survey-loader.gif'
      } */
    ],
  })


  useLocalStorageRouteCheck(localStorageKey, allowedRouteNames);
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator color="rgb(var(--color-primary-500))" />
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
